import { render, staticRenderFns } from "./TransactionLogisticsList.vue?vue&type=template&id=37258e58&scoped=true&"
import script from "./TransactionLogisticsList.vue?vue&type=script&lang=js&"
export * from "./TransactionLogisticsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37258e58",
  null
  
)

export default component.exports